"use strict";

var _classCallCheck = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");
/**
 * Class representing a transaction signer for pubkeyhash addresses
 * (a.k.a. single-sig addresses)
 * @private
 * @ignore
 */


var PubkeyHashSigner =
/*#__PURE__*/
function () {
  function PubkeyHashSigner(ecPair) {
    _classCallCheck(this, PubkeyHashSigner);

    this.ecPair = ecPair;
  }

  _createClass(PubkeyHashSigner, [{
    key: "signerVersion",
    value: function signerVersion() {
      return 1;
    }
  }, {
    key: "getAddress",
    value: function getAddress() {
      var _this = this;

      return Promise.resolve().then(function () {
        return utils_1.ecPairToAddress(_this.ecPair);
      });
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(transaction, inputIndex) {
      var _this2 = this;

      return Promise.resolve().then(function () {
        transaction.sign(inputIndex, _this2.ecPair);
      });
    }
  }], [{
    key: "fromHexString",
    value: function fromHexString(keyHex) {
      return new PubkeyHashSigner(utils_1.hexStringToECPair(keyHex));
    }
  }]);

  return PubkeyHashSigner;
}();

exports.PubkeyHashSigner = PubkeyHashSigner;